import { createJSONStorage, persist } from "zustand/middleware"
import { UserProfileEntity } from "@/modules/users/entities/usersEntity"
import { create } from "@/modules/core/store"
import { STORAGE_ZUSTAND_KEYS } from "@/modules/core/store"

type AppStateAuthenticatedUser = {
  user: UserProfileEntity
  isAuthenticated: true
}

type AppStateUnauthenticatedUser = {
  user: null
  isAuthenticated: false
}

type AppStateActions = {
  actions: {
    setAppStateUser: (appState: { user: UserProfileEntity | null }) => void
  }
}

type AppState = (AppStateAuthenticatedUser | AppStateUnauthenticatedUser) & AppStateActions

export const useAppStateStore = create<AppState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      actions: {
        setAppStateUser: (appState) => {
          if (appState.user) {
            set({
              user: appState.user,
              isAuthenticated: true,
            })
          } else {
            set({
              user: null,
              isAuthenticated: false,
            })
          }
        },
      },
    }),
    {
      name: STORAGE_ZUSTAND_KEYS.USER_AUTHENTICATION,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    },
  ),
)

export const useAppStateUser = () => {
  return useAppStateStore((state) => state.user)
}

export const useAppStateIsAuthenticated = () => {
  return useAppStateStore((state) => state.isAuthenticated)
}

export const useAppStateActions = () => {
  return useAppStateStore((state) => state.actions)
}
